import { render, staticRenderFns } from "./basket_info.vue?vue&type=template&id=396bb024&"
import script from "./basket_info.vue?vue&type=script&lang=js&"
export * from "./basket_info.vue?vue&type=script&lang=js&"
import style0 from "./basket_info.vue?vue&type=style&index=0&id=396bb024&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports